import React from 'react';
import PropTypes from 'prop-types';
import { CtaButton } from '../CtaButton';
import { useReporter } from '../../reporter';
import { Carousel } from '../../molecules';
import { BackgroundColorContainer } from '../../atoms';
import { BeforeAfterTestimonial } from '../BeforeAfterTestimonial';
import { Testimonial } from './Testimonial';
import {
  TestimonialsContainer,
  Headline,
  ButtonContainer,
  CarouselContainer,
  SubHeadline,
  ContainerHeader,
} from './styles';
import { testimonialsButtonClicked, testimonialsCarouselTurn } from './events';

export const Testimonials = ({
  testimonials,
  headline,
  showStars,
  link,
  subheadline,
  backgroundColor,
}) => {
  const reporter = useReporter();
  const onTestimonialsClicked = target => {
    reporter.tag(testimonialsCarouselTurn(target));
  };
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 600, itemsToShow: 2, itemsToScroll: 1, pagination: false },
    { width: 768, itemsToShow: 3, itemsToScroll: 1, pagination: false },
    { width: 960, itemsToShow: 4, itemsToScroll: 1, pagination: false },
  ];
  return (
    <BackgroundColorContainer bgColor={backgroundColor || 'background.base'}>
      <TestimonialsContainer>
        <ContainerHeader>
          {headline && <Headline>{headline}</Headline>}
          {subheadline && <SubHeadline>{subheadline}</SubHeadline>}
        </ContainerHeader>

        <CarouselContainer>
          <Carousel
            breakPoints={breakPoints}
            itemsToShow={1}
            onArrowClick={target => onTestimonialsClicked(target)}
            onDotClick={() => onTestimonialsClicked('dots')}
            buttonPosition={'45'}
          >
            {testimonials.map((testimonial, i) =>
              testimonial.component === 'before_after_testimonial' ? (
                <BeforeAfterTestimonial key={i} {...testimonial} />
              ) : (
                <Testimonial
                  showStars={showStars}
                  {...testimonial}
                  key={testimonial.name}
                />
              ),
            )}
          </Carousel>
        </CarouselContainer>
        {link && (
          <ButtonContainer>
            <CtaButton
              href={link.target}
              variant="sweetPotato"
              onClick={() =>
                reporter.tag(testimonialsButtonClicked(link.text, link.target))
              }
            >
              {link.text}
            </CtaButton>
          </ButtonContainer>
        )}
      </TestimonialsContainer>
    </BackgroundColorContainer>
  );
};

Testimonials.displayName = 'Testimonials';

Testimonials.propTypes = {
  testimonials: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      component: PropTypes.string,
    }),
  ).isRequired,
  headline: PropTypes.string,
  link: PropTypes.shape({
    target: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
  showStars: PropTypes.bool,
  subheadline: PropTypes.string,
  backgroundColor: PropTypes.string,
};
